import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import main translations
import enTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';
import zhCNTranslations from './locales/zh-CN.json';
import hiTranslations from './locales/hi.json';
import frTranslations from './locales/fr.json';
import ptBRTranslations from './locales/pt-BR.json';
import esTranslations from './locales/es.json';

// Import legal translations
import enLegal from './locales/legal/en.json';
import ruLegal from './locales/legal/ru.json';
import zhCNLegal from './locales/legal/zh-CN.json';
import hiLegal from './locales/legal/hi.json';
import frLegal from './locales/legal/fr.json';
import ptBRLegal from './locales/legal/pt-BR.json';
import esLegal from './locales/legal/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
        legal: enLegal
      },
      ru: {
        translation: ruTranslations,
        legal: ruLegal
      },
      'zh-CN': {
        translation: zhCNTranslations,
        legal: zhCNLegal
      },
      hi: {
        translation: hiTranslations,
        legal: hiLegal
      },
      fr: {
        translation: frTranslations,
        legal: frLegal
      },
      'pt-BR': {
        translation: ptBRTranslations,
        legal: ptBRLegal
      },
      es: {
        translation: esTranslations,
        legal: esLegal
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru', 'zh-CN', 'hi', 'fr', 'pt-BR', 'es'],
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

// Обработчик смены языка
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n; 